import { UserImpersonationMovedNotice } from 'components';
import { IAppReducer } from 'models/reducer.interface';
import { useSelector } from 'react-redux';

interface IUserImpersonationGuardProps {
  children: JSX.Element;
}

/**
 * CB-40: el módulo legacy de User Impersonation (/sales, /sales/*) deja de
 * ser la superficie autoritativa — solo is_tester (control/QA) lo sigue
 * usando sin cambios. Un agente normal nunca llega a ver el módulo, ni de
 * forma transitoria: este guard reemplaza el contenido de la ruta por el
 * aviso de que ahora se hace en app.consoda, en vez de dejar pasar a `children`.
 */
export const UserImpersonationGuard = ({
  children,
}: IUserImpersonationGuardProps) => {
  const { isTester } = useSelector((state: IAppReducer) => state.authReducer);

  if (!isTester) {
    return <UserImpersonationMovedNotice />;
  }

  return children;
};
